import AiOldPhotoRestorationIcon from '../assets/svg/ai-old-photo-restoration.svg?react';
import AiFaceSwapIcon from '../assets/svg/ai-face-swap.svg?react';
import AiPhotoColorizerIcon from '../assets/svg/ai-photo-colorizer.svg?react';
import AiImageGeneratorIcon from '../assets/svg/ai-image-generator.svg?react';
import AiImageUpscalerIcon from '../assets/svg/ai-image-upscaler.svg?react';
import AiImageToImageIcon from '../assets/svg/ai-image-to-image.svg?react';
import AiImageExtenderIcon from '../assets/svg/ai-image-extender.svg?react';
import AiObjectEraserIcon from '../assets/svg/ai-object-eraser-icon.svg?react';
import AiImageBgRemoverIcon from '../assets/svg/bg-remove.svg?react';
import AiClothesChangerIcon from '../assets/svg/ai-clothes-changer.svg?react';
import AiVideoGeneratorIcon from '../assets/svg/ai-video-generator.svg?react';
import AiFake3dIcon from '../assets/svg/fake-3d.svg?react';
import AiAudioGeneratorIcon from '../assets/svg/ai-music.svg?react';
import AiVideoRemoveBgIcon from '../assets/svg/video-background-remover.svg?react';
import AiVideoToAISfxGeneratorIcon from '../assets/svg/video-to-ai-sfx.svg?react';
import AITextBasedEditingIcon from '../assets/svg/ai-text-based-editing.svg?react';
import FJTextToFullVideoIcon from '../assets/svg/textToVideo/text-to-full-video.svg?react';
import FJBlogUrlToVideoIcon from '../assets/svg/textToVideo/blog-url-to-video.svg?react';
import FJProductUrlToAdsIcon from '../assets/svg/textToVideo/product-url-to-ads.svg?react';
import FJPptToVideoIcon from '../assets/svg/textToVideo/ppt-to-video.svg?react';
import { RELEASE } from '../constants/FJEvnConstant';
const environment = import.meta.env.MODE;
const isRelease = environment !== RELEASE;
const FJHeaderConfig = {
    // 电脑端菜单列表(从上到下，从左到右排列), 新增工具需要到less文件修改gird布局
    aiMenuList: [
        {
            hasMobile: true,
            title: 'ai-image-to-image',
            icon: AiImageToImageIcon,
            href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
        },
        {
            title: '3d-photo-animation',
            icon: AiFake3dIcon,
            href: isRelease ? '/apply/3d-photo-animation/' : '/ai/3d-photo-animation/',
        },
        {
            hasMobile: true,
            title: 'ai-text-to-image',
            icon: AiImageGeneratorIcon,
            href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
        },
        {
            hasMobile: true,
            title: 'ai-old-photo-restoration',
            icon: AiOldPhotoRestorationIcon,
            href: isRelease ? '/apply/old-photo-restoration/' : '/ai/old-photo-restoration/',
        },
        {
            hasMobile: true,
            title: 'ai-face-swap',
            icon: AiFaceSwapIcon,
            href: isRelease ? '/apply/face-swap/' : '/ai/face-swap/',
        },
        {
            hasMobile: true,
            title: 'ai-image-extender',
            icon: AiImageExtenderIcon,
            href: isRelease ? '/apply/image-extender/' : '/ai/image-extender/',
        },
        {
            hasMobile: false,
            title: 'ai-clothes-changer',
            icon: AiClothesChangerIcon,
            href: isRelease ? '/apply/clothes-changer/' : '/ai/clothes-changer/',
        },
        {
            hasMobile: true,
            title: 'ai-object-eraser',
            icon: AiObjectEraserIcon,
            href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
        },
        {
            title: 'ai-image-bg-remover',
            icon: AiImageBgRemoverIcon,
            href: isRelease ? '/apply/image-background-remover/' : '/ai/image-background-remover/',
        },
        {
            hasMobile: true,
            title: 'ai-image-upscaler',
            icon: AiImageUpscalerIcon,
            href: isRelease ? '/apply/image-upscaler/' : '/ai/image-upscaler/',
        },
        {
            hasMobile: true,
            title: 'ai-photo-colorizer',
            icon: AiPhotoColorizerIcon,
            href: isRelease ? '/apply/photo-colorizer/' : '/ai/photo-colorizer/',
        },

        {
            title: 'ai-video-generator',
            icon: AiVideoGeneratorIcon,
            href: isRelease ? '/apply/video-generator/' : '/ai/video-generator/',
        },
        {
            title: 'ai-text-to-full-video',
            icon: FJTextToFullVideoIcon,
            href: isRelease ? '/apply/text-to-full-video/' : '/ai/text-to-full-video/',
        },
        {
            title: 'ai-blog-url-to-video',
            icon: FJBlogUrlToVideoIcon,
            href: isRelease ? '/apply/blog-url-to-video/' : '/ai/blog-url-to-video/',
        },
        {
            title: 'ai-product-url-to-video',
            icon: FJProductUrlToAdsIcon,
            href: isRelease ? '/apply/product-url-to-ads/' : '/ai/product-url-to-ads/',
        },
        {
            title: 'ai-ppt-to-video',
            icon: FJPptToVideoIcon,
            href: isRelease ? '/apply/ppt-to-video/' : '/ai/ppt-to-video/',
        },

        {
            title: 'ai-music-generator',
            icon: AiAudioGeneratorIcon,
            href: isRelease ? '/apply/music-generator/' : '/ai/music-generator/',
        },
        {
            title: 'ai-video-bg-remover',
            icon: AiVideoRemoveBgIcon,
            href: isRelease ? '/apply/video-background-remover/' : '/ai/video-background-remover/',
        },
        {
            title: 'ai-video-dub',
            icon: AiVideoToAISfxGeneratorIcon,
            href: isRelease ? '/apply/video-to-ai-sfx-generator/' : '/ai/video-to-ai-sfx-generator/',
        },
        {
            title: 'ai-text-based-editing',
            icon: AITextBasedEditingIcon,
            href: isRelease ? '/apply/ai-text-based-editing/' : '/ai/ai-text-based-editing/',
        },
    ],
    // 移动端菜单列表(从上到下排列)
    mobileMenuList: [
        {
            title: 'ai-old-photo-restoration',
            icon: AiOldPhotoRestorationIcon,
            href: isRelease ? '/apply/old-photo-restoration/' : '/ai/old-photo-restoration/',
        },
        {
            title: 'ai-face-swap',
            icon: AiFaceSwapIcon,
            href: isRelease ? '/apply/face-swap/' : '/ai/face-swap/',
        },
        {
            title: 'ai-photo-colorizer',
            icon: AiPhotoColorizerIcon,
            href: isRelease ? '/apply/photo-colorizer/' : '/ai/photo-colorizer/',
        },
        {
            title: 'ai-text-to-image',
            icon: AiImageGeneratorIcon,
            href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
        },
        {
            title: 'ai-image-upscaler',
            icon: AiImageUpscalerIcon,
            href: isRelease ? '/apply/image-upscaler/' : '/ai/image-upscaler/',
        },
        {
            title: 'ai-image-to-image',
            icon: AiImageToImageIcon,
            href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
        },
        {
            title: 'ai-image-extender',
            icon: AiImageExtenderIcon,
            href: isRelease ? '/apply/image-extender/' : '/ai/image-extender/',
        },
        {
            title: 'ai-object-eraser',
            icon: AiObjectEraserIcon,
            href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
        },
    ],
};

export default FJHeaderConfig;
